/* Gaxilo video cards: play muted while on screen, tap for sound. Safe to load more than once. */
(function () {
  if (window.__gxVideosReady) return;
  window.__gxVideosReady = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function initVideos(root) {
    (root || document).querySelectorAll('[data-gx-videos]').forEach(function (section) {
      if (section.dataset.gxVideosInit) return;
      section.dataset.gxVideosInit = '1';
      var autoplay = section.dataset.autoplay !== 'false' && !reduceMotion;
      var frames = Array.prototype.slice.call(section.querySelectorAll('[data-gx-video]'));

      frames.forEach(function (frame) {
        var video = frame.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.removeAttribute('controls');
        var sound = frame.querySelector('[data-gx-sound]');

        function sync() {
          frame.classList.toggle('is-playing', !video.paused);
          frame.classList.toggle('is-unmuted', !video.muted);
          if (sound) {
            sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
            sound.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
          }
        }
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        video.addEventListener('volumechange', sync);

        frame.addEventListener('click', function (e) {
          if (e.target.closest('[data-gx-sound]')) return;
          if (video.paused) {
            delete frame.dataset.userPaused;
            play(video);
          } else {
            frame.dataset.userPaused = '1';
            video.pause();
          }
        });

        if (sound) {
          sound.addEventListener('click', function () {
            var turnOn = video.muted;
            frames.forEach(function (other) {
              var v = other.querySelector('video');
              if (v && v !== video) v.muted = true;
            });
            video.muted = !turnOn;
            if (turnOn && video.paused) {
              delete frame.dataset.userPaused;
              play(video);
            }
          });
        }
        sync();
      });

      if (!autoplay || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.intersectionRatio >= 0.6) {
            if (!entry.target.dataset.userPaused) play(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: [0, 0.6, 1] });
      frames.forEach(function (frame) { io.observe(frame); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initVideos(); });
  } else {
    initVideos();
  }
  document.addEventListener('shopify:section:load', function (e) { initVideos(e.target); });
})();
